import { render, staticRenderFns } from "./footer-comp.vue?vue&type=template&id=04c0bdba&scoped=true"
import script from "./footer-comp.vue?vue&type=script&lang=js"
export * from "./footer-comp.vue?vue&type=script&lang=js"
import style0 from "./footer-comp.vue?vue&type=style&index=0&id=04c0bdba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04c0bdba",
  null
  
)

export default component.exports